
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#1d1d1b"},attrs:{"d":"M39.69,51.45l17.66-17.67h0c.97-.97,.97-2.55,0-3.52L39.68,12.55c-.97-.97-2.55-.97-3.52,0h0c-.97,.97-.97,2.54,0,3.51,0,0,0,0,0,0l13.4,13.44H8.42c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5H49.56l-13.41,13.41c-.98,.98-.98,2.56,0,3.54,.98,.98,2.56,.98,3.54,0Z"}})])
          )
        }
      }
    